// extracted by mini-css-extract-plugin
export default {"header":"mW_yxd","hasSwitchPlanNotification":"Fv9I_n","withBoxShadow":"EZpzzV","inSale":"f5Oyw_","saleBannerContainer":"Twm_PE"};